import {
  PlacementChoice
} from '@/builders/pizza/dataTransformers/builderTypes';
import Placement from '@/common/Placement';

export const getPlacement = (positions?: number[]): PlacementChoice => {
  if (!positions) {
    return Placement.WHOLE;
  }

  const [left, right] = positions;

  if (right === undefined) return Placement.WHOLE;

  return left === 0 ? Placement.RIGHT : Placement.LEFT;
};
